import React from 'react'
import { PROGRESS_LINE_TEST_ID } from '@chegg-wt/core-wa/constants/paraphraser'
import { Container, ProgressBarSplit } from './styled'
import { ProgressLineProps } from './types'

const ProgressLine: React.FC<ProgressLineProps> = ({
  progressBarPercentage,
  progressBarColor,
  defaultColor,
}) => (
  <Container data-test={`${PROGRESS_LINE_TEST_ID}-score`} defaultColor={defaultColor}>
    <ProgressBarSplit
      data-test={`${PROGRESS_LINE_TEST_ID}-split`}
      progressBarPercentage={progressBarPercentage}
      progressBarColor={progressBarColor}
    />
  </Container>
)

export default ProgressLine
